import apiHandler from "../core/apiHandler";

const quotationApi = apiHandler("quotations");

export default quotationApi;